/* Murano Classics: lysekronekalkulator (seksjonen mc-calculator).
   Regner alltid i cm internt. Tommer er bare visning og inndata.

   Oppheng (fra Gustav 09.10.2026):
   - Korteste: bare nederste stag i kroken. Total høyde = lampens høyde + 15 cm.
   - Nederste stag og kjetting: lampens høyde + 15 cm + kjetting.
   - To stag med kjetting mellom: lampens høyde + 30 cm + kjetting (minst ca. 4 cm). Ser mest ut som en lysekrone.
   - Medfølgende kjetting gir «høyde med kjede». Lengre kjetting kan bestilles. */
(function () {
  "use strict";
  var IN = 2.54, ROD = 15, LINK = 4;

  function r5(v) { return Math.round(v / 5) * 5; }
  function clamp(v, a, b) { return Math.min(Math.max(v, a), b); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function f(n) { return n.toFixed(1); }

  // Mål fra metafeltet custom.spec_dimensjoner (oversatt). Stopper ved første tomme linje (glassmålene).
  function parseSpec(txt) {
    var out = { d: null, h: null, chain: null };
    if (!txt) return out;
    txt.split(/\n\s*\n/)[0].split(/\n/).forEach(function (line) {
      var m = line.match(/(\d+(?:[.,]\d+)?)\s*cm/i);
      if (!m) return;
      var v = parseFloat(m[1].replace(",", "."));
      if (/diam|durchm/i.test(line)) { if (out.d == null) out.d = v; }
      else if (/uten|without|ohne|sans|senza|zonder/i.test(line)) { if (out.h == null) out.h = v; }
      else if (/kjede|chain|kette|cha[iî]ne|catena|ketting/i.test(line)) { if (out.chain == null) out.chain = v; }
      else if (out.h == null) { out.h = v; }
    });
    return out;
  }

  function shapeOf(title, setting) {
    if (setting && setting !== "auto") return setting;
    var t = title || "";
    if (/poliedri|poliedro/i.test(t)) return "poliedri";
    if (/prism/i.test(t)) return "prisms";
    if (/dr[åa]pe|drop|tropfen|goccia|gocce|goutte|druppel/i.test(t)) return "drops";
    if (/palm/i.test(t)) return "leaves";
    if (/kongle|pine|cone|pigna|zapfen|petal|kronblad|blad|leaf/i.test(t)) return "petals";
    return "tubes";
  }

  // Oppheng ut fra avstanden S fra tak til toppen av lampen.
  function hang(S) {
    if (S < ROD + LINK) return { type: "rod", chain: 0, S: ROD };
    if (S < 2 * ROD + LINK) return { type: "rodChain", chain: S - ROD, S: S };
    return { type: "two", chain: S - 2 * ROD, S: S };
  }

  function rulesDining(v, TH) {
    var dMin = v.w * 0.5, dMax = Math.max(dMin, Math.min(v.w * 2 / 3, v.w - 30));
    var extra = Math.max(0, (v.c - 270) / 30 * 7.5);
    var cMin = r5(75 + extra), cMax = r5(90 + extra);
    return { dMin: dMin, dMax: dMax, cMin: cMin, cMax: cMax, dropMin: v.c - TH - cMax, dropMax: v.c - TH - cMin,
      long: v.l >= 220, dTwo: Math.max(dMin, Math.min(dMax, v.l / 2 - 30)) };
  }
  // Stue og entré: bare høyden teller. Fri høyde kan brukeren selv endre (standard 200 cm).
  function rulesRoom(v) {
    return { free: v.f, space: v.c - v.f };
  }

  // Anbefalt høyde på selve lysekronen (uten stag og kjetting): 0,21-0,25 x takhøyden
  // (2,5-3 tommer per fot), men aldri mer enn det som får plass med bare nederste stag.
  // drop = avstanden fra tak til underkant vi sikter mot.
  function recommend(r, mode, c) {
    var maxH = (mode === "room" ? r.space : r.dropMax) - ROD;
    var hi = Math.min(r5(c * 0.25), r5(maxH)), lo = Math.min(r5(c * 0.21), hi);
    var drop = mode === "room" ? r.space : (r.dropMin + r.dropMax) / 2;
    return { lo: lo, hi: hi, ok: hi >= 30, sLo: Math.max(ROD, r5(drop - hi)), sHi: Math.max(ROD, r5(drop - lo)) };
  }

  function plan(mode, lamp, r, v, TH, FREE) {
    var H = lamp.h;
    if (H == null) return { status: "unknown" };
    var lo, hi, S;
    if (mode === "room") {
      hi = r.space - H;
      if (hi < ROD) return { status: "tall", S: ROD };
      var supplied = lamp.chain != null ? Math.max(ROD, lamp.chain - H) : hi;
      S = Math.max(ROD, Math.min(hi, supplied));
      lo = ROD;
    } else {
      hi = r.dropMax - H;
      if (hi < ROD) return { status: "tall", S: ROD };
      lo = Math.max(ROD, r.dropMin - H);
      S = clamp((r.dropMin + r.dropMax) / 2 - H, lo, hi);
    }
    var Sr = r5(S);
    if (Sr >= lo && Sr <= hi) S = Sr;
    var h = hang(S);
    // «Anbefalt» (fit): lysekronen har anbefalt høyde, og over spisebordet også en diameter som passer bordet.
    // Ellers «Passer» (ok) så lenge den får plass i høyden.
    var rec = r.rec, inH = rec && rec.ok && H >= rec.lo - 5 && H <= rec.hi + 5;
    var inD = mode !== "dining" || (lamp.d != null && lamp.d >= r.dMin - 3 && lamp.d <= r.dMax + 3);
    var status = inH && inD ? "fit" : "ok";
    return { status: status, S: h.S, hang: h, longer: lamp.chain != null && h.S > lamp.chain - H + 0.5 };
  }

  // ---------- Tegning ----------
  function el(name, attrs) { var s = "<" + name; for (var k in attrs) if (attrs[k] != null) s += " " + k + '="' + attrs[k] + '"'; return s + "/>"; }
  function line(x1, y1, x2, y2, cls, extra) { return el("line", { x1: f(x1), y1: f(y1), x2: f(x2), y2: f(y2), "class": cls, style: extra }); }
  function txt(x, y, s, cls, anchor) { return '<text x="' + f(x) + '" y="' + f(y) + '" class="' + (cls || "") + '" text-anchor="' + (anchor || "start") + '">' + esc(s) + "</text>"; }
  function hdim(x1, x2, y, label, below) {
    return line(x1, y, x2, y, "dim") + line(x1, y - 5, x1, y + 5, "dim") + line(x2, y - 5, x2, y + 5, "dim") + txt((x1 + x2) / 2, below ? y + 20 : y - 8, label, "t-dim", "middle");
  }
  function vdim(x, y1, y2, label, side) {
    var tx = side === "left" ? x - 9 : x + 9;
    return line(x, y1, x, y2, "dim") + line(x - 5, y1, x + 5, y1, "dim") + line(x - 5, y2, x + 5, y2, "dim") + txt(tx, (y1 + y2) / 2 + 5, label, "t-dim", side === "left" ? "end" : "start");
  }

  function ring(n, r) {
    var out = [];
    for (var j = 0; j < n; j++) { var a = (2 * Math.PI * j) / n + 0.13; out.push({ dx: r * Math.cos(a), z: Math.sin(a) }); }
    return out.sort(function (a, b) { return a.z - b.z; });
  }
  function glassPath(shape, x, y, w, L, rot) {
    if (shape === "drops") {
      // smal topp, bredest rundt 70 %, rund bunn, som dråpeglassene våre
      var hw = w / 2;
      return '<path d="M' + f(x) + " " + f(y) + " C" + f(x + hw * 0.55) + " " + f(y + L * 0.22) + " " + f(x + hw) + " " + f(y + L * 0.5) + " " + f(x + hw) + " " + f(y + L * 0.74) +
        " C" + f(x + hw) + " " + f(y + L * 0.93) + " " + f(x + hw * 0.45) + " " + f(y + L) + " " + f(x) + " " + f(y + L) +
        " C" + f(x - hw * 0.45) + " " + f(y + L) + " " + f(x - hw) + " " + f(y + L * 0.93) + " " + f(x - hw) + " " + f(y + L * 0.74) +
        " C" + f(x - hw) + " " + f(y + L * 0.5) + " " + f(x - hw * 0.55) + " " + f(y + L * 0.22) + " " + f(x) + " " + f(y) + ' Z"';
    }
    if (shape === "petals") {
      // kongleblad: bredest øverst, spiss nederst
      var pw = w / 2;
      return '<path d="M' + f(x) + " " + f(y) + " C" + f(x + pw) + " " + f(y) + " " + f(x + pw) + " " + f(y + L * 0.35) + " " + f(x + pw * 0.85) + " " + f(y + L * 0.55) +
        " L" + f(x) + " " + f(y + L) + " L" + f(x - pw * 0.85) + " " + f(y + L * 0.55) +
        " C" + f(x - pw) + " " + f(y + L * 0.35) + " " + f(x - pw) + " " + f(y) + " " + f(x) + " " + f(y) + ' Z"';
    }
    if (shape === "prisms") {
      // prismer: smale, rette sider og skrå bunn
      return '<path d="M' + f(x - w / 2) + " " + f(y) + " L" + f(x + w / 2) + " " + f(y) + " L" + f(x + w / 2) + " " + f(y + L * 0.86) + " L" + f(x) + " " + f(y + L) + " L" + f(x - w / 2) + " " + f(y + L * 0.86) + ' Z"';
    }
    if (shape === "poliedri") {
      return '<path d="M' + f(x) + " " + f(y) + " L" + f(x + w / 2) + " " + f(y + 0.38 * L) + " L" + f(x + w * 0.22) + " " + f(y + L) + " L" + f(x - w * 0.22) + " " + f(y + L) + " L" + f(x - w / 2) + " " + f(y + 0.38 * L) + ' Z"';
    }
    if (shape === "leaves") {
      return '<ellipse cx="' + f(x) + '" cy="' + f(y + L / 2) + '" rx="' + f(w / 2) + '" ry="' + f(L / 2) + '" transform="rotate(' + f(rot || 0) + " " + f(x) + " " + f(y + L / 2) + ')"';
    }
    return '<rect x="' + f(x - w / 2) + '" y="' + f(y) + '" width="' + f(w) + '" height="' + f(L) + '" rx="' + f(w / 2) + '"';
  }

  // Lysekrona sett forfra: glass i ringer, nivå for nivå, bakerste glass først.
  function chandelier(shape, cx, yT, Dp, Hp, k) {
    var cfg = {
      tubes: { tiers: Hp / k < 55 ? 3 : 4, shrink: 0.2, w: 6.5, L: Hp * 0.5 },
      drops: { tiers: 4, shrink: 0.21, w: 8, L: Math.min(32 * k, Hp * 0.5) },
      poliedri: { tiers: 5, shrink: 0.12, w: 7, L: Math.max(7, 15 * k) },
      leaves: { tiers: 3, shrink: 0.24, w: 6, L: Math.max(10, 24 * k) },
      petals: { tiers: 4, shrink: 0.2, w: 8, L: Math.min(Math.max(10, 27 * k), Hp * 0.45) },
      prisms: { tiers: 4, shrink: 0.17, w: 3.2, L: Math.min(Math.max(10, 22 * k), Hp * 0.5) }
    }[shape] || { tiers: 3, shrink: 0.2, w: 6.5, L: Hp * 0.5 };
    var w = Math.max(3, cfg.w * k), L = Math.min(cfg.L, Hp * 0.92), frameH = Math.max(3, 3 * k);
    var step = cfg.tiers > 1 ? (Hp - frameH - L) / (cfg.tiers - 1) : 0;
    var back = "", front = [];
    for (var i = 0; i < cfg.tiers; i++) {
      var r = Math.max(w, Dp / 2 * (1 - i * cfg.shrink) - w / 2);
      var gap = shape === "drops" || shape === "petals" ? 1.15 : shape === "prisms" ? 1.8 : 1.35;
      var n = Math.max(6, Math.round((2 * Math.PI * r) / (w * gap)));
      var y = yT + frameH + i * step, fr = "";
      ring(n, r).forEach(function (g) {
        var rot = shape === "leaves" ? (g.dx / r) * 50 : 0;
        var gx = cx + g.dx, p = glassPath(shape, gx, y, w, L, rot);
        if (g.z < 0) { back += p + ' class="g-back"/>'; return; }
        fr += p + ' class="g-front"/>';
        // glans: en tynn lys strek i glasset som vender mot oss
        if ((shape === "tubes" || shape === "drops" || shape === "petals") && w >= 5 && g.z > 0.35) {
          var hx = gx - w * 0.18;
          fr += line(hx, y + L * (shape === "drops" ? 0.42 : 0.12), hx, y + L * (shape === "drops" ? 0.82 : 0.86), "g-shine");
        }
      });
      front.push(fr);
    }
    var crown = el("ellipse", { cx: f(cx), cy: f(yT + frameH / 2), rx: f(Math.max(6, Dp * 0.16)), ry: f(frameH / 2), "class": "metal" });
    // innerste (nederste) nivå først, ytterste (øverste) sist, så de nærmeste glassene ligger øverst
    return back + front.reverse().join("") + crown;
  }

  // Kopp, stag og kjetting fra taket ned til toppen av lampen.
  function suspension(cx, y0, h, k) {
    var s = "", cupW = Math.max(24, 13 * k), cupH = Math.max(10, 6 * k), rodW = Math.max(3, 1.5 * k), y = y0;
    var parts = h.type === "rod" ? [["rod", ROD]] : h.type === "rodChain" ? [["chain", h.chain], ["rod", ROD]] : [["rod", ROD], ["chain", h.chain], ["rod", ROD]];
    parts.forEach(function (p) {
      var len = p[1] * k;
      if (p[0] === "rod") {
        s += el("rect", { x: f(cx - rodW / 2), y: f(y), width: f(rodW), height: f(len), "class": "metal" });
      } else {
        var lh = Math.max(4, 2.2 * k), n = Math.max(1, Math.round(len / lh));
        for (var i = 0; i < n; i++) {
          var yy = y + i * (len / n) + len / n / 2;
          s += i % 2 === 0 ? el("ellipse", { cx: f(cx), cy: f(yy), rx: f(Math.max(2.4, 0.9 * k)), ry: f(len / n / 2 + 0.6), "class": "metal" })
            : line(cx, yy - len / n / 2 - 0.6, cx, yy + len / n / 2 + 0.6, "ln", "stroke-width:2");
        }
      }
      y += len;
    });
    // ring der staget møter lampen
    s += el("circle", { cx: f(cx), cy: f(y), r: f(rodW * 0.9), "class": "metal" });
    // takkoppen: en kuppel med en liten krage under, som koppene våre
    var colW = cupW * 0.26, colH = Math.max(3, 2 * k);
    s += '<path d="M' + f(cx - cupW / 2) + " " + f(y0) + " C" + f(cx - cupW / 2) + " " + f(y0 + cupH * 0.9) + " " + f(cx - cupW * 0.2) + " " + f(y0 + cupH) + " " + f(cx) + " " + f(y0 + cupH) +
      " C" + f(cx + cupW * 0.2) + " " + f(y0 + cupH) + " " + f(cx + cupW / 2) + " " + f(y0 + cupH * 0.9) + " " + f(cx + cupW / 2) + " " + f(y0) + ' Z" class="metal"/>';
    s += el("rect", { x: f(cx - colW / 2), y: f(y0 + cupH - 0.5), width: f(colW), height: f(colH), "class": "metal" });
    return s;
  }

  // Målestokkfigur, 178 cm, i samme strek som arkitekttegninger.
  function person(x, yF, k) {
    var H = 178 * k, top = yF - H, P = function (a, b) { return f(x + a * H) + " " + f(top + b * H); };
    var head = el("ellipse", { cx: f(x), cy: f(top + 0.065 * H), rx: f(0.05 * H), ry: f(0.062 * H) });
    var body = '<path d="M' + P(-0.02, 0.13) + " L" + P(-0.115, 0.17) + " L" + P(-0.1, 0.5) + " L" + P(-0.06, 0.52) + " L" + P(-0.055, 1) +
      " M" + P(0.02, 0.13) + " L" + P(0.115, 0.17) + " L" + P(0.1, 0.5) + " L" + P(0.06, 0.52) + " L" + P(0.055, 1) +
      " M" + P(-0.115, 0.17) + " L" + P(-0.085, 0.53) + " L" + P(0.085, 0.53) + " L" + P(0.115, 0.17) +
      " M" + P(0, 0.56) + " L" + P(0, 0.98) + '"/>';
    return '<g class="person">' + head + body + "</g>";
  }

  function init(root) {
    var cfg = JSON.parse(root.querySelector("[data-config]").textContent);
    var t = cfg.t || {}, mode = cfg.mode || "dining", TH = cfg.tableHeight || 75, FREE = cfg.freeHeight || 200;
    var inputs = {};
    root.querySelectorAll("input[data-k]").forEach(function (e) { inputs[e.getAttribute("data-k")] = e; });
    var svg = root.querySelector("[data-svg]");
    var out = function (k) { return root.querySelector('[data-out="' + k + '"]'); };
    var unit = "cm", picked = null, expanded = false;
    var SHOW = cfg.initial || 8;
    var moreBtn = root.querySelector("[data-more]");
    if (moreBtn) moreBtn.addEventListener("click", function () { expanded = !expanded; update(true); });
    var last = {};
    Object.keys(inputs).forEach(function (k) { last[k] = parseFloat(inputs[k].value) || 0; });

    var lamps = Array.prototype.slice.call(root.querySelectorAll("[data-card]")).map(function (li, i) {
      var p = parseSpec(li.getAttribute("data-spec"));
      ["d", "h", "chain"].forEach(function (k) { var o = parseFloat(li.getAttribute("data-" + k)); if (!isNaN(o) && o > 0) p[k] = o; });
      var title = (li.getAttribute("data-title") || "").replace(/^[^|]*\|\s*/, "");
      var lamp = { i: i, li: li, d: p.d, h: p.h, chain: p.chain, title: title, shape: shapeOf(li.getAttribute("data-title"), li.getAttribute("data-shape")),
        fit: li.querySelector("[data-fit]"), meta: li.querySelector("[data-meta]"), susp: li.querySelector("[data-susp]"), btn: li.querySelector("[data-show]") };
      if (lamp.btn) lamp.btn.addEventListener("click", function () { picked = i; update(true); });
      return lamp;
    });

    function u(v) { return unit === "in" ? Math.round(v / IN) : Math.round(v); }
    function un() { return unit === "in" ? (t.unitIn || "in") : "cm"; }
    function one(v) { return u(v) + " " + un(); }
    function range(a, b) { return u(a) + "–" + u(b) + " " + un(); }
    function hangText(p) {
      if (!p.hang) return "";
      var s = p.hang.type === "rod" ? t.rod : (p.hang.type === "rodChain" ? t.rodChain : t.two).replace("{c}", one(p.hang.chain));
      return s + (p.longer && t.longer ? ", " + t.longer : "");
    }

    function read() {
      Object.keys(inputs).forEach(function (k) {
        var v = parseFloat(String(inputs[k].value).replace(",", "."));
        if (!isNaN(v) && v > 0) last[k] = unit === "in" ? v * IN : v;
      });
      if (last.c != null) last.c = clamp(last.c, 200, 800);
      if (last.w != null) last.w = clamp(last.w, 50, 300);
      if (last.l != null) last.l = clamp(last.l, 50, 800);
      if (last.f != null) last.f = clamp(last.f, 100, 300);
      return last;
    }

    function draw(v, r, lamp, p) {
      var y0 = 48, yF = 650, left = 112, right = 624, cx = 392;
      var k = (yF - y0) / v.c;
      var widest = Math.max(mode === "dining" ? v.w : 0, lamp && lamp.d ? lamp.d : 0);
      if (widest * k > 420) { k = 420 / widest; yF = y0 + v.c * k; }
      var s = "";
      s += line(left, y0, right, y0, "ln");
      for (var x = left + 8; x <= right; x += 12) s += line(x, y0, x - 8, y0 - 8, "hatch");
      s += line(left, yF, right, yF, "ln");
      for (x = left + 8; x <= right; x += 12) s += line(x, yF, x - 8, yF + 8, "hatch");
      s += txt(right, y0 + 20, t.ceiling || "", "t-muted", "end");
      // takhøyden: loddrett tekst langs målestreken, så den ikke kuttes på smale skjermer
      var hx = left - 30, hy = (y0 + yF) / 2;
      s += line(hx, y0, hx, yF, "dim") + line(hx - 5, y0, hx + 5, y0, "dim") + line(hx - 5, yF, hx + 5, yF, "dim");
      s += '<text x="' + f(hx - 9) + '" y="' + f(hy) + '" class="t-dim" text-anchor="middle" transform="rotate(-90 ' + f(hx - 9) + " " + f(hy) + ')">' + esc(one(v.c)) + "</text>";

      var tTop = mode === "dining" ? yF - TH * k : null;
      if (mode === "dining") {
        var tl = cx - v.w / 2 * k, tr = cx + v.w / 2 * k;
        s += el("rect", { x: f(tl), y: f(tTop), width: f(tr - tl), height: f(Math.max(4, 4 * k)), "class": "wood" });
        s += line(tl + 7, tTop + 4, tl + 7, yF, "ln") + line(tr - 7, tTop + 4, tr - 7, yF, "ln");
        s += txt(cx, tTop + 24, t.table || "", "t-muted", "middle");
        s += hdim(tl, tr, yF + 30, one(v.w), true);
      } else {
        var fy = yF - r.free * k;
        s += line(left, fy, right, fy, "ln-soft", "stroke-dasharray:5 5");
        s += txt(left + 4, fy - 8, (t.free || "{h}").replace("{h}", one(r.free)), "t-muted", "start");
      }

      if (lamp && lamp.h != null && lamp.d != null) {
        var h = p.hang || hang(ROD);
        var Dp = lamp.d * k, Hp = lamp.h * k, yT = y0 + h.S * k, yB = yT + Hp;
        s += suspension(cx, y0, h, k);
        s += chandelier(lamp.shape, cx, yT, Dp, Hp, k);
        var dimL = cx - Dp / 2 - 22;
        s += vdim(dimL, y0, yT, one(h.S), "left");
        s += hdim(cx - Dp / 2, cx + Dp / 2, yB + 14, (t.dia || "Ø") + " " + one(lamp.d), true);
        var dx = Math.min(right - 6, cx + Dp / 2 + 26);
        if (mode === "dining") {
          s += vdim(dx, yB, tTop, one(v.c - TH - lamp.h - h.S), dx > right - 70 ? "left" : "right");
        } else {
          s += vdim(dx, yB, yF, one(v.c - lamp.h - h.S), dx > right - 70 ? "left" : "right");
          // personen står til venstre for lysekronen, så målene til høyre får være i fred
          var px = Math.max(left + 40, (left + (cx - Dp / 2)) / 2);
          s += person(px, yF, k);
        }
      }
      var title = svg.querySelector("title");
      svg.innerHTML = "";
      if (title) svg.appendChild(title);
      svg.insertAdjacentHTML("beforeend", s);
    }

    function update(keep) {
      var v = keep ? last : read();
      var r = mode === "room" ? rulesRoom(v) : rulesDining(v, TH);
      r.rec = recommend(r, mode, v.c);
      out("rec").textContent = r.rec.ok ? range(r.rec.lo, r.rec.hi) : "–";
      out("susp").textContent = r.rec.ok ? (r.rec.sLo === r.rec.sHi ? one(r.rec.sLo) : range(r.rec.sLo, r.rec.sHi)) : "–";
      if (mode === "room") out("space").textContent = one(r.space);
      else { out("d").textContent = range(r.dMin, r.dMax); out("clear").textContent = range(r.cMin, r.cMax); }

      var plans = lamps.map(function (l) { return plan(mode, l, r, v, TH, FREE); });
      var rank = { fit: 0, ok: 1, unknown: 2, tall: 3 };
      var hMid = (r.rec.lo + r.rec.hi) / 2;
      // Sorter: anbefalt først, så de som passer, så de som er for høye. Innenfor hver gruppe: høyden nærmest anbefalt.
      var sorted = lamps.map(function (l, i) { return i; }).sort(function (a, b) {
        var ra = rank[plans[a].status] != null ? rank[plans[a].status] : 2, rb = rank[plans[b].status] != null ? rank[plans[b].status] : 2;
        if (ra !== rb) return ra - rb;
        if (lamps[a].h != null && lamps[b].h != null) return Math.abs(lamps[a].h - hMid) - Math.abs(lamps[b].h - hMid);
        return a - b;
      });
      var n = 0;
      sorted.forEach(function (i, pos) {
        var l = lamps[i], p = plans[i];
        if (p.status === "fit" || p.status === "ok") n++;
        l.li.style.order = String(pos);
        l.li.hidden = !expanded && pos >= SHOW;
        l.li.classList.toggle("is-off", p.status === "tall");
        if (l.fit) { var lbl = t[p.status]; l.fit.textContent = lbl || ""; l.fit.hidden = !lbl; l.fit.setAttribute("data-status", p.status); }
        if (l.meta) l.meta.textContent = [l.d != null ? (t.dia || "Ø") + " " + one(l.d) : "", l.h != null ? (t.height || "") + " " + one(l.h) : ""].filter(Boolean).join(", ");
        if (l.susp) l.susp.textContent = p.status === "tall" ? "" : hangText(p);
      });
      if (moreBtn) { moreBtn.hidden = lamps.length <= SHOW; moreBtn.textContent = expanded ? t.showLess : (t.showAll || "").replace("{n}", lamps.length); moreBtn.setAttribute("aria-expanded", expanded ? "true" : "false"); }

      // Hvilken modell tegnes: den brukeren valgte, ellers den øverste i lista.
      var pick = picked != null ? picked : sorted[0];
      lamps.forEach(function (l, i) { if (l.btn) { var on = i === pick; l.btn.setAttribute("aria-pressed", on ? "true" : "false"); l.btn.textContent = on ? (t.shown || t.show) : t.show; l.li.classList.toggle("is-picked", on); } });

      var note = out("note"), msg = "";
      if (mode === "dining" && r.long && t.long) msg = t.long.replace("{d}", one(r.dTwo));
      if (mode === "room" && lamps.length && plans.every(function (p) { return p.status === "tall"; }) && t.noneRoom) msg = t.noneRoom.replace("{c}", one(v.c));
      note.textContent = msg; note.hidden = !msg;

      var cnt = out("count");
      if (cnt && lamps.length) cnt.textContent = n ? (t.count || "").replace("{n}", n).replace("{total}", lamps.length) : (t.none || "");
      var lamp = lamps[pick], p = plans[pick] || {};
      var cap = out("caption");
      if (cap) cap.textContent = lamp && p.hang ? (t.caption || "").replace("{p}", lamp.title).replace("{s}", hangText(p)) : "";
      if (svg) draw(v, r, lamp, p);
    }

    function setUnit(nu) {
      if (nu === unit) return;
      read();
      unit = nu;
      Object.keys(inputs).forEach(function (k) { inputs[k].value = u(last[k]); });
      root.querySelectorAll("[data-unit]").forEach(function (e) { e.textContent = un(); });
      update(true);
    }

    Object.keys(inputs).forEach(function (k) { inputs[k].addEventListener("input", function () { update(false); }); });
    root.querySelectorAll('input[type="radio"]').forEach(function (rb) { rb.addEventListener("change", function () { if (rb.checked) setUnit(rb.value); }); });
    update(false);
  }

  function boot() { document.querySelectorAll("[data-mc-calc]").forEach(function (root) { if (!root.__mc) { root.__mc = true; init(root); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
